import imageCompression from 'browser-image-compression'

// Görsel sıkıştırma ayarları
export const COMPRESSION_OPTIONS = {
  // Yüksek kalite ayarları (ürün görselleri için)
  high: {
    maxSizeMB: 2, // Maksimum dosya boyutu (MB)
    maxWidthOrHeight: 2048, // Maksimum genişlik/yükseklik
    useWebWorker: true,
    quality: 0.9, // Kalite (0-1 arası)
    alwaysKeepResolution: false
  },
  
  // Orta kalite ayarları (genel kullanım için)
  medium: {
    maxSizeMB: 1, // Maksimum dosya boyutu (MB)
    maxWidthOrHeight: 1920, // Maksimum genişlik/yükseklik
    useWebWorker: true,
    quality: 0.8, // Kalite (0-1 arası)
    alwaysKeepResolution: false
  },
  
  // Düşük kalite ayarları (hızlı yükleme için)
  low: {
    maxSizeMB: 0.5, // Maksimum dosya boyutu (MB)
    maxWidthOrHeight: 1280, // Maksimum genişlik/yükseklik
    useWebWorker: true,
    quality: 0.7, // Kalite (0-1 arası)
    alwaysKeepResolution: false
  }
}

// Görsel sıkıştırma fonksiyonu
export const compressImage = async (file, quality = 'medium') => {
  try {
    // Görsel dosyası kontrolü
    if (!file.type.startsWith('image/')) {
      throw new Error('Sadece görsel dosyalar yüklenebilir')
    }

    // Sıkıştırma seçenekleri
    const compressionOptions = {
      ...COMPRESSION_OPTIONS[quality],
      fileType: file.type
    }

    // Görsel sıkıştırma
    console.log('Orijinal dosya boyutu:', (file.size / 1024 / 1024).toFixed(2), 'MB')
    const compressedFile = await imageCompression(file, compressionOptions)
    console.log('Sıkıştırılmış dosya boyutu:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB')
    
    const compressionRatio = ((1 - compressedFile.size / file.size) * 100).toFixed(1)
    console.log('Sıkıştırma oranı:', compressionRatio + '%')

    return {
      file: compressedFile,
      originalSize: file.size,
      compressedSize: compressedFile.size,
      compressionRatio: compressionRatio,
      error: null
    }
  } catch (error) {
    console.error('Görsel sıkıştırma hatası:', error)
    return {
      file: null,
      originalSize: file.size,
      compressedSize: 0,
      compressionRatio: 0,
      error: error.message
    }
  }
}

// Dosya boyutunu formatla
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

// Çoklu dosya sıkıştırma
export const compressMultipleImages = async (files, quality = 'medium', onProgress) => {
  const results = []
  
  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    const result = await compressImage(file, quality)
    results.push(result)
    
    // Progress callback
    if (onProgress) {
      onProgress({
        current: i + 1,
        total: files.length,
        fileName: file.name,
        result: result
      })
    }
  }
  
  return results
} 